export const DEFAULT_BACKOFF_BASE_MS = 1000;
export const DEFAULT_BACKOFF_MAX_MS = 30_000;
/**
 * Full-jitter backoff (AWS architecture blog formula): `delay = random(0, min(cap, base * 2^attempt))`.
 * `attempt` is 0-indexed (the first retry after the initial drop is attempt 0).
 */
export function computeBackoffMs(attempt, opts = {}) {
    const base = opts.baseMs ?? DEFAULT_BACKOFF_BASE_MS;
    const max = opts.maxMs ?? DEFAULT_BACKOFF_MAX_MS;
    const random = opts.random ?? Math.random;
    const clampedAttempt = Math.max(0, Math.floor(attempt));
    const exp = base * 2 ** clampedAttempt;
    const upperBound = Math.min(max, exp);
    return Math.floor(random() * upperBound);
}
